// ═══════════════════════════════════════════════════════════════════════════════
// Usage region — stored in users.settings.usageRegion (stable code keys)
// ═══════════════════════════════════════════════════════════════════════════════
export const USAGE_REGION = {
    HK: 'hk',
    SG: 'sg',
    CN: 'cn',
    MO: 'mo',
    IN: 'in',
    ID: 'id',
    JP: 'jp',
    MY: 'my',
    PH: 'ph',
    SA: 'sa',
    KR: 'kr',
    TW: 'tw',
    TH: 'th',
    AE: 'ae',
    VN: 'vn',
    ASIA_OTHER: 'asia_other',
    DK: 'dk',
    FI: 'fi',
    FR: 'fr',
    DE: 'de',
    IE: 'ie',
    IT: 'it',
    NL: 'nl',
    NO: 'no',
    PT: 'pt',
    ES: 'es',
    SE: 'se',
    CH: 'ch',
    GB: 'gb',
    EUROPE_OTHER: 'europe_other',
    AR: 'ar',
    BR: 'br',
    CA: 'ca',
    CL: 'cl',
    CO: 'co',
    MX: 'mx',
    US: 'us',
    AMERICAS_OTHER: 'americas_other',
    AU: 'au',
    NZ: 'nz',
    OCEANIA_OTHER: 'oceania_other',
    EG: 'eg',
    ZA: 'za',
    AFRICA_OTHER: 'africa_other',
};
export const USAGE_REGION_GROUP = {
    ASIA: 'asia',
    EUROPE: 'europe',
    AMERICAS: 'americas',
    OCEANIA: 'oceania',
    AFRICA: 'africa',
};
export const DEFAULT_USAGE_REGION = USAGE_REGION.HK;
export const USAGE_REGION_VALUES = Object.values(USAGE_REGION);
export const isUsageRegion = (value) => USAGE_REGION_VALUES.includes(value);
/** Ordered groups and regions for dropdown UI (group labels are not selectable). */
export const USAGE_REGION_GROUPS = [
    {
        group: USAGE_REGION_GROUP.ASIA,
        regions: [
            USAGE_REGION.HK,
            USAGE_REGION.SG,
            USAGE_REGION.CN,
            USAGE_REGION.MO,
            USAGE_REGION.IN,
            USAGE_REGION.ID,
            USAGE_REGION.JP,
            USAGE_REGION.MY,
            USAGE_REGION.PH,
            USAGE_REGION.SA,
            USAGE_REGION.KR,
            USAGE_REGION.TW,
            USAGE_REGION.TH,
            USAGE_REGION.AE,
            USAGE_REGION.VN,
            USAGE_REGION.ASIA_OTHER,
        ],
    },
    {
        group: USAGE_REGION_GROUP.EUROPE,
        regions: [
            USAGE_REGION.DK,
            USAGE_REGION.FI,
            USAGE_REGION.FR,
            USAGE_REGION.DE,
            USAGE_REGION.IE,
            USAGE_REGION.IT,
            USAGE_REGION.NL,
            USAGE_REGION.NO,
            USAGE_REGION.PT,
            USAGE_REGION.ES,
            USAGE_REGION.SE,
            USAGE_REGION.CH,
            USAGE_REGION.GB,
            USAGE_REGION.EUROPE_OTHER,
        ],
    },
    {
        group: USAGE_REGION_GROUP.AMERICAS,
        regions: [
            USAGE_REGION.AR,
            USAGE_REGION.BR,
            USAGE_REGION.CA,
            USAGE_REGION.CL,
            USAGE_REGION.CO,
            USAGE_REGION.MX,
            USAGE_REGION.US,
            USAGE_REGION.AMERICAS_OTHER,
        ],
    },
    {
        group: USAGE_REGION_GROUP.OCEANIA,
        regions: [USAGE_REGION.AU, USAGE_REGION.NZ, USAGE_REGION.OCEANIA_OTHER],
    },
    {
        group: USAGE_REGION_GROUP.AFRICA,
        regions: [USAGE_REGION.EG, USAGE_REGION.ZA, USAGE_REGION.AFRICA_OTHER],
    },
];
//# sourceMappingURL=usageRegion.js.map